"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadinessStatus = void 0;
var ReadinessStatus;
(function (ReadinessStatus) {
    ReadinessStatus["NOT_DEPLOYED"] = "not-deployed";
    ReadinessStatus["NOT_READY"] = "not-ready";
    ReadinessStatus["READY"] = "ready";
})(ReadinessStatus || (exports.ReadinessStatus = ReadinessStatus = {}));
//# sourceMappingURL=ReadinessStatus.js.map